export const RECEIVE_PRODUCT_VARIATION_RESULT = 'RECEIVE_PRODUCT_VARIATION_RESULT';
export const RECEIVE_ADDONS_RESULT = 'RECEIVE_ADDONS_RESULT';
export const IN_FLIGHT = 'IN_FLIGHT';
